const LoginData = {
    en: {
        // ── Login ─────────────────────────────────────────────────────────────────
        title:             'Sign In',
        subtitle:          'Welcome back, please enter your details',
        emailLabel:        'Email',
        emailPlaceholder:  'user@company.com',
        passwordLabel:     'Password',
        passwordPlaceholder: '••••••••',
        loginBtn:          'Sign In',
        noAccount:         "Don't have an account?",
        signUp:            'Sign Up',
        orDivider:         'or',
        backBtn:           'Back',
        rememberMe:        'Remember this device',
        forgotPassword:    'Forgot password?',
        // ── Forgot Password ───────────────────────────────────────────────────────
        forgotTitle:       'Reset Password',
        forgotSubtitle:    "Enter your email and we'll send you a reset link",
        forgotBtn:         'Send Reset Link',
        forgotSuccess:     'Check your inbox — we sent a reset link to',
        resendHint:        "Didn't get the email?",
        resendBtn:         'Resend',
        resendCooldown:    'Resend in',
        backToLogin:       'Back to Sign In',
        // ── Reset Password ────────────────────────────────────────────────────────
        resetTitle:        'New Password',
        resetSubtitle:     'Choose a strong password for your account',
        newPasswordLabel:  'New Password',
        confirmPasswordLabel: 'Confirm Password',
        resetBtn:          'Set New Password',
        passwordMismatch:  'Passwords do not match',
        // ── Register ──────────────────────────────────────────────────────────────
        registerTitle:     'Create Account',
        registerSubtitle:  'Join our wholesale network',
        nameLabel:         'Full Name',
        namePlaceholder:   'Your name',
        registerBtn:       'Create Account',
        haveAccount:       'Already have an account?',
        signIn:            'Sign In',
        smsConsentLabel:   'Receive SMS updates & promotions',
        emailConsentLabel: 'Receive email newsletters & offers',
        consentNote:       'You can unsubscribe at any time.',
    },
    he: {
        // ── Login ─────────────────────────────────────────────────────────────────
        title:             'התחברות',
        subtitle:          'ברוכים השבים, נא להזין פרטים',
        emailLabel:        'אימייל',
        emailPlaceholder:  'user@company.com',
        passwordLabel:     'סיסמה',
        passwordPlaceholder: '••••••••',
        loginBtn:          'התחבר',
        noAccount:         'אין לך חשבון?',
        signUp:            'הרשמה',
        orDivider:         'או',
        backBtn:           'חזור',
        rememberMe:        'זכור את המכשיר הזה',
        forgotPassword:    'שכחת סיסמה?',
        // ── Forgot Password ───────────────────────────────────────────────────────
        forgotTitle:       'איפוס סיסמה',
        forgotSubtitle:    'הזן את האימייל שלך ונשלח לך קישור לאיפוס',
        forgotBtn:         'שלח קישור לאיפוס',
        forgotSuccess:     'בדוק את תיבת הדואר שלך — שלחנו קישור לאיפוס אל',
        resendHint:        'לא קיבלת את האימייל?',
        resendBtn:         'שלח שוב',
        resendCooldown:    'שלח שוב בעוד',
        backToLogin:       'חזרה להתחברות',
        // ── Reset Password ────────────────────────────────────────────────────────
        resetTitle:        'סיסמה חדשה',
        resetSubtitle:     'בחר סיסמה חזקה לחשבון שלך',
        newPasswordLabel:  'סיסמה חדשה',
        confirmPasswordLabel: 'אישור סיסמה',
        resetBtn:          'הגדר סיסמה חדשה',
        passwordMismatch:  'הסיסמאות אינן תואמות',
        // ── Register ──────────────────────────────────────────────────────────────
        registerTitle:     'יצירת חשבון',
        registerSubtitle:  'הצטרפו לרשת הסיטונאים שלנו',
        nameLabel:         'שם מלא',
        namePlaceholder:   'השם שלך',
        registerBtn:       'יצירת חשבון',
        haveAccount:       'יש לך חשבון?',
        signIn:            'התחבר',
        smsConsentLabel:   'קבלת עדכונים ומבצעים ב-SMS',
        emailConsentLabel: 'קבלת ניוזלטרים ומבצעים באימייל',
        consentNote:       'ניתן לבטל את המנוי בכל עת.',
    }
};

export function getLoginData(language) {
    return LoginData[language] || LoginData.en;
}

export default LoginData;
